<template>
    <div class="historico-inativacao-list px-4">
        <div class="table-container">
            <b-table id="historico-inativacao-temp" striped responsive :items="rows" :fields="headerFields">
            </b-table>
        </div>
    </div>
</template>

<script>

let headerFields = [
    {key: 'nome', label: "Nome", thClass: 'px-2', tdClass: 'px-2'},
    {key: 'empresa', label: "Empresa", thClass: 'px-2', tdClass: 'px-2'},
    {key: 'data', label: 'Data', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'hora', label: 'Hora', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'tipo', label: 'Tipo', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'responsavel', label: 'Responsável pela inativação', thClass: 'px-2', tdClass: 'px-2'},
]

let columnsKeys = [
   'nome', 
   'empresa',
   'data', 
   'hora', 
   'tipo', 
   'responsavel',
]

export default {
    name: "HistoricoInativacaoList",
    props: {
		rows: Array
	},
    data() {
        return {
            headerFields: [
                ...headerFields.filter(head => columnsKeys.includes(head.key)),
            ],
            lastFilter: {},
            page: 1,
        }

    },
}
</script>
<style scoped>
.table-container .table-responsive {
	font-size: small;
}
</style>